// store.ts
import {configureStore} from '@reduxjs/toolkit';
import visibilityReducer from 'Redux/visibilitySlice';
import psychologyParamsReducer from 'Redux/psychologyParamsSlice';


const store = configureStore({
    reducer: {
        visibility: visibilityReducer,
        psychologyParams: psychologyParamsReducer,
    },
});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;